enum TokenConstants {
  ALTERAR_SENHA = 'ext_alterarSenha',
  CD_PESSOA_FISICA = 'ext_codigoPessoa',
  DS_LOGIN = 'sub',
  NR_SEQ_BENEFICIARIO = 'ext_nrSeqBeneficiario',
}

export default TokenConstants;
